export const translations = {
  nl: {
    nav: { home: "Home", services: "Diensten", contact: "Contact", book: "Boek afspraak", admin: "Admin", manage: "Afspraak annuleren/wijzigen" },
    common: {
      loading: "Laden...", save: "Opslaan", saving: "Opslaan...", cancel: "Annuleren", close: "Sluiten",
      back: "Terug", next: "Volgende", confirm: "Bevestigen", edit: "Bewerken", delete: "Verwijderen",
      add: "Toevoegen", yes: "Ja", no: "Nee", required: "verplicht", minutes: "min", euro: "€",
      saved: "Opgeslagen", actions: "Acties", search: "Zoeken", status: "Status", active: "Actief", inactive: "Inactief",
    },
    header: { bookNow: "Boek afspraak", callUs: "Bel ons" },
    hero: {
      title: "EliteTheBarber",
      subtitle: "Premium barbershop in het hart van Utrecht. Vakmanschap, stijl en een uitstekende ervaring bij elk bezoek.",
      cta: "Boek afspraak",
      ctaSecondary: "Bekijk diensten",
      ratingText: "op basis van {{count}} Google reviews",
    },
    usps: {
      title: "Waarom EliteTheBarber",
      items: [
        { title: "5,0 / 5 sterren", text: "Beoordeeld met een perfecte score op basis van 37 Google reviews." },
        { title: "Persoonlijke aandacht", text: "Vakmanschap en oog voor detail bij elke behandeling." },
        { title: "Centraal in Utrecht", text: "Gemakkelijk te bereiken aan de Vlampijpstraat 75g." },
        { title: "Eenvoudig online boeken", text: "Kies je dienst, datum en tijd — direct bevestigd." },
      ],
    },
    services: {
      title: "Diensten & Prijzen", subtitle: "Transparante prijzen voor elke behandeling.",
      minutesLabel: "min", bookThis: "Boek deze dienst",
      comingSoonTitle: "Binnenkort beschikbaar", comingSoonText: "Onze volledige dienstenlijst wordt binnenkort hier gepubliceerd.",
      viewAll: "Bekijk alle diensten",
    },
    about: {
      title: "Over EliteTheBarber",
      text: "EliteTheBarber is een barbershop gevestigd aan de Vlampijpstraat 75g in Utrecht. Wij staan voor vakmanschap, kwaliteit en een prettige ervaring bij elk bezoek.",
    },
    reviews: {
      title: "Wat klanten zeggen", subtitle: "Echte beoordelingen van onze klanten via Google.",
      basedOn: "op basis van 37 Google reviews", source: "Bron: Google Reviews",
    },
    hours: {
      title: "Openingstijden", closed: "Gesloten",
      days: { 0: "Maandag", 1: "Dinsdag", 2: "Woensdag", 3: "Donderdag", 4: "Vrijdag", 5: "Zaterdag", 6: "Zondag" },
    },
    location: {
      title: "Locatie", directions: "Routebeschrijving", viewOnMaps: "Bekijk op Google Maps",
    },
    contact: {
      title: "Contact", subtitle: "Neem contact op of maak direct een afspraak.",
      phone: "Telefoon", email: "E-mail", address: "Adres", hoursTitle: "Openingstijden", bookCta: "Boek nu een afspraak",
      form: {
        title: "Stuur ons een bericht", subtitle: "Vul het formulier in en we reageren zo snel mogelijk.",
        name: "Naam", email: "E-mailadres", phone: "Telefoonnummer (optioneel)", message: "Bericht",
        namePlaceholder: "Je naam", emailPlaceholder: "naam@voorbeeld.nl", phonePlaceholder: "06 12345678",
        messagePlaceholder: "Waarmee kunnen we je helpen?",
        submit: "Verstuur bericht", sending: "Versturen...",
        successTitle: "Bericht verzonden!", successMessage: "Bedankt voor je bericht. We nemen zo snel mogelijk contact met je op.",
        errorMessage: "Er ging iets mis bij het versturen. Probeer het later opnieuw of bel ons direct.",
      },
    },
    footer: {
      tagline: "Premium barbershop in Utrecht.", quickLinks: "Snelle links", legal: "Juridisch",
      rights: "Alle rechten voorbehouden.",
      privacy: "Privacyverklaring", cookies: "Cookiebeleid", terms: "Algemene voorwaarden",
      admin: "Beheer", manageAppointment: "Afspraak annuleren",
    },
    cookieBanner: {
      text: "Deze website gebruikt uitsluitend noodzakelijke en functionele cookies om goed te functioneren (zoals je taalvoorkeur en inlogsessie). Er worden geen tracking- of marketingcookies gebruikt.",
      accept: "Begrepen", moreInfo: "Meer info",
    },
    booking: {
      title: "Boek je afspraak",
      steps: { service: "Dienst", date: "Datum", time: "Tijd", info: "Gegevens", confirm: "Bevestigen" },
      selectService: "Kies een dienst", selectDate: "Kies een datum", selectTime: "Kies een tijdstip",
      noServices: "Er zijn momenteel geen diensten beschikbaar. Neem telefonisch contact op.",
      noSlots: "Geen beschikbare tijden op deze dag. Kies een andere datum.",
      loadingSlots: "Beschikbare tijden laden...",
      form: {
        name: "Volledige naam", email: "E-mailadres", phone: "Telefoonnummer", notes: "Opmerkingen (optioneel)",
        namePlaceholder: "Jouw naam", emailPlaceholder: "naam@voorbeeld.nl", phonePlaceholder: "06 12345678",
        notesPlaceholder: "Eventuele wensen of opmerkingen",
      },
      consent: {
        text: "Ik ga akkoord met de", terms: "algemene voorwaarden", and: "en heb kennisgenomen van de",
        privacy: "privacyverklaring", required: "Je moet akkoord gaan om je afspraak te bevestigen.",
      },
      summary: {
        title: "Controleer je afspraak", service: "Dienst", date: "Datum", time: "Tijd", price: "Prijs",
        duration: "Duur", customer: "Naam", email: "E-mail", phone: "Telefoon",
      },
      confirmButton: "Afspraak bevestigen", confirming: "Bevestigen...",
      success: {
        title: "Afspraak bevestigd!", message: "Je afspraak is succesvol ingepland. Tot snel bij EliteTheBarber!",
        reference: "Afspraaknummer", backHome: "Terug naar home", newBooking: "Nieuwe afspraak maken",
        keepNumber: "Bewaar dit nummer goed, je hebt het nodig om je afspraak te annuleren.",
        manageLink: "Afspraak annuleren?",
        spamTip: "Geen bevestigingsmail ontvangen na een paar minuten? Check je spam/ongewenste-mail map en markeer de mail als \"geen spam\" — dan komen toekomstige e-mails van ons gewoon in je inbox terecht.",
      },
      errors: {
        slotTaken: "Dit tijdslot is niet meer beschikbaar. Kies een ander tijdstip.",
        invalidData: "Controleer je ingevulde gegevens.", serverError: "Er ging iets mis. Probeer het later opnieuw.",
        noAvailability: "Geen beschikbaarheid gevonden.", serviceUnavailable: "Deze dienst is niet beschikbaar.",
        generic: "Er is een fout opgetreden.",
      },
      changeSelection: "Wijzig keuze",
    },
    cancelPage: {
      title: "Afspraak annuleren", confirmText: "Weet je zeker dat je deze afspraak wilt annuleren? Dit kan niet ongedaan worden gemaakt.",
      confirmButton: "Ja, annuleer mijn afspraak", cancelledTitle: "Afspraak geannuleerd",
      cancelledMessage: "Je afspraak is succesvol geannuleerd. We hopen je snel weer te zien!",
      invalidLink: "Deze link is ongeldig of verlopen.", manageLink: "Afspraak liever wijzigen?",
      policyNote: "Gratis annuleren of wijzigen kan tot 12 uur voor je afspraak. Bij annuleren binnen 12 uur, of bij no-show, brengen we 50% van het tarief in rekening.",
    },
    reschedulePage: {
      title: "Afspraak wijzigen", currentAppointment: "Huidige afspraak", newTime: "Nieuwe datum en tijd",
      confirmButton: "Wijziging bevestigen", confirming: "Bevestigen...", successTitle: "Afspraak gewijzigd!",
      successMessage: "Je afspraak is succesvol verplaatst.", cancelLink: "Afspraak liever annuleren?",
      policyNote: "Gratis wijzigen kan tot 12 uur voor je afspraak. Bij wijzigen binnen 12 uur, of bij no-show, brengen we 50% van het tarief in rekening.",
    },
    manageAppointmentPage: {
      title: "Afspraak annuleren", subtitle: "Vul je afspraaknummer en e-mailadres in om je afspraak op te zoeken.",
      appointmentNumber: "Afspraaknummer", appointmentNumberPlaceholder: "Bijv. 00003",
      email: "E-mailadres", emailPlaceholder: "Het e-mailadres waarmee je hebt geboekt",
      searchButton: "Afspraak zoeken", searching: "Zoeken...",
      notFound: "We konden geen afspraak vinden met deze gegevens. Controleer je afspraaknummer en e-mailadres.",
      foundTitle: "Afspraak gevonden", alreadyCancelled: "Deze afspraak is al geannuleerd.",
      confirmText: "Weet je zeker dat je deze afspraak wilt annuleren?",
      cancelButton: "Afspraak annuleren", back: "Terug", cancelling: "Annuleren...",
      cancelledTitle: "Afspraak geannuleerd", cancelledMessage: "Je afspraak is succesvol geannuleerd. We hopen je snel weer te zien!",
      newSearch: "Andere afspraak zoeken",
    },
    legal: {
      privacyTitle: "Privacyverklaring", cookiesTitle: "Cookiebeleid", termsTitle: "Algemene voorwaarden",
      lastUpdated: "Laatst bijgewerkt",
    },
    admin: {
      login: {
        title: "Admin login", email: "E-mailadres", password: "Wachtwoord", submit: "Inloggen",
        invalidCredentials: "Ongeldig e-mailadres of wachtwoord", forgotPassword: "Wachtwoord vergeten?",
      },
      resetPassword: {
        title: "Nieuw wachtwoord instellen", newPassword: "Nieuw wachtwoord", confirmPassword: "Bevestig wachtwoord",
        submit: "Wachtwoord instellen", success: "Wachtwoord succesvol gewijzigd. Je kunt nu inloggen.",
        mismatch: "Wachtwoorden komen niet overeen", tooShort: "Wachtwoord moet minstens 8 tekens zijn",
        invalidToken: "Deze link is ongeldig of verlopen. Vraag een nieuwe aan.", goToLogin: "Naar inloggen",
        missingToken: "Geen resettoken gevonden in de link.",
      },
      nav: {
        dashboard: "Dashboard", calendar: "Agenda", bookings: "Boekingen", availability: "Beschikbaarheid",
        services: "Diensten", photos: "Foto's", messages: "Berichten", reports: "Rapportage", settings: "Instellingen", logout: "Uitloggen", backToSite: "Naar website",
      },
      dashboard: {
        title: "Dashboard", todayAppointments: "Afspraken vandaag", upcoming: "Komende 7 dagen",
        totalBookings: "Totaal boekingen", revenueMonth: "Omzet deze maand", quickActions: "Snelle acties",
        newBooking: "Nieuwe boeking toevoegen", viewCalendar: "Bekijk agenda", manageServices: "Beheer diensten",
        noAppointmentsToday: "Geen afspraken vandaag.", upcomingAppointments: "Aankomende afspraken",
        todayPanelTitle: "Vandaag", noUpcoming: "Geen aankomende afspraken.",
      },
      calendar: {
        title: "Agenda", day: "Dag", week: "Week", month: "Maand", today: "Vandaag",
        noAppointments: "Geen afspraken", prev: "Vorige", next: "Volgende",
      },
      bookings: {
        title: "Boekingen", all: "Alle", confirmed: "Bevestigd", cancelled: "Geannuleerd",
        newBooking: "Nieuwe boeking", customer: "Klant", service: "Dienst", date: "Datum", time: "Tijd",
        price: "Prijs", noBookings: "Geen boekingen gevonden.", cancelBooking: "Annuleren",
        deleteBooking: "Verwijderen", confirmCancel: "Weet je zeker dat je deze boeking wilt annuleren?",
        confirmDelete: "Weet je zeker dat je deze boeking permanent wilt verwijderen?",
        editBooking: "Boeking bewerken", details: "Details", notes: "Opmerkingen", source: "Herkomst",
        appointmentNumber: "Afspraaknummer", searchPlaceholder: "Zoek op nummer, naam, e-mail, telefoon of datum...",
        formDescription: "Vul de gegevens van de afspraak in en klik op opslaan.",
      },
      availability: {
        title: "Beschikbaarheid", workingHours: "Werktijden", breaks: "Pauzes", blockedTimes: "Geblokkeerde tijden / Vakanties",
        open: "Open", closed: "Gesloten", startTime: "Starttijd", endTime: "Eindtijd", addBreak: "Pauze toevoegen",
        addBlocked: "Uitzondering toevoegen", fullDay: "Hele dag", reason: "Reden", startDate: "Startdatum", endDate: "Einddatum",
        weekday: "Dag", label: "Omschrijving", noBreaks: "Geen pauzes ingesteld.", noBlocked: "Geen uitzonderingen ingesteld.",
      },
      services: {
        title: "Diensten & Prijzen", addService: "Dienst toevoegen", editService: "Dienst bewerken",
        nameNl: "Naam (NL)", nameEn: "Naam (EN)", descriptionNl: "Beschrijving (NL)", descriptionEn: "Beschrijving (EN)",
        price: "Prijs (€)", duration: "Duur (min)", order: "Volgorde", isActive: "Actief", noServices: "Nog geen diensten toegevoegd.",
        image: "Foto", uploadImage: "Foto uploaden",
      },
      photos: {
        title: "Foto's beheren", upload: "Foto uploaden", section: "Sectie", altTextNl: "Alt-tekst (NL)",
        altTextEn: "Alt-tekst (EN)", noPhotos: "Nog geen foto's geüpload.", moveUp: "Omhoog", moveDown: "Omlaag",
        edit: "Bewerken", editPhoto: "Foto bewerken", replaceImage: "Afbeelding vervangen (optioneel)",
        save: "Opslaan", saving: "Opslaan...", cancel: "Annuleren", deleteConfirm: "Weet je zeker dat je deze foto wilt verwijderen?",
        sections: { hero: "Hero", about: "Over ons", services: "Diensten", gallery: "Galerij", contact: "Contact", carousel: "Carrousel" },
      },
      messages: {
        title: "Contactberichten", noMessages: "Nog geen berichten ontvangen.", markRead: "Markeer als gelezen",
        deleteConfirm: "Bericht verwijderen", deleteConfirmDescription: "Weet je zeker dat je dit bericht permanent wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
        unread: "Ongelezen", name: "Naam", email: "E-mail", phone: "Telefoon", message: "Bericht", date: "Datum",
      },
      reports: {
        title: "Rapportage", totalAppointments: "Afspraken", totalRevenue: "Omzet", averagePrice: "Gem. prijs per afspraak",
        cancelledCount: "Geannuleerd", byService: "Uitsplitsing per dienst", chartTitle: "Omzet per dag", chartTitleYear: "Omzet per maand",
        noData: "Geen afspraken in deze periode.", service: "Dienst", count: "Aantal", revenue: "Omzet",
        prevMonth: "Vorige maand", nextMonth: "Volgende maand", prevYear: "Vorig jaar", nextYear: "Volgend jaar",
        monthView: "Maand", yearView: "Jaar",
      },
      settings: {
        title: "Instellingen", businessInfo: "Bedrijfsgegevens", legalInfo: "Juridische gegevens",
        businessName: "Bedrijfsnaam", legalName: "Wettelijke bedrijfsnaam", kvkNumber: "KvK-nummer",
        phone: "Telefoon", email: "E-mailadres", privacyEmail: "Privacy e-mailadres", address: "Adres",
        postalCode: "Postcode", city: "Plaats", country: "Land", mapsUrl: "Google Maps embed URL",
        reviewScore: "Reviewscore", reviewCount: "Aantal reviews", retention: "Bewaartermijn gegevens (maanden)",
      },
    },
  },
  en: {
    nav: { home: "Home", services: "Services", contact: "Contact", book: "Book appointment", admin: "Admin", manage: "Cancel/reschedule appointment" },
    common: {
      loading: "Loading...", save: "Save", saving: "Saving...", cancel: "Cancel", close: "Close",
      back: "Back", next: "Next", confirm: "Confirm", edit: "Edit", delete: "Delete",
      add: "Add", yes: "Yes", no: "No", required: "required", minutes: "min", euro: "€",
      saved: "Saved", actions: "Actions", search: "Search", status: "Status", active: "Active", inactive: "Inactive",
    },
    header: { bookNow: "Book appointment", callUs: "Call us" },
    hero: {
      title: "EliteTheBarber",
      subtitle: "Premium barbershop in the heart of Utrecht. Craftsmanship, style and an excellent experience every visit.",
      cta: "Book appointment",
      ctaSecondary: "View services",
      ratingText: "based on {{count}} Google reviews",
    },
    usps: {
      title: "Why EliteTheBarber",
      items: [
        { title: "5.0 / 5 stars", text: "Rated with a perfect score based on 37 Google reviews." },
        { title: "Personal attention", text: "Craftsmanship and attention to detail in every treatment." },
        { title: "Central in Utrecht", text: "Easily accessible at Vlampijpstraat 75g." },
        { title: "Easy online booking", text: "Choose your service, date and time — instantly confirmed." },
      ],
    },
    services: {
      title: "Services & Prices", subtitle: "Transparent pricing for every treatment.",
      minutesLabel: "min", bookThis: "Book this service",
      comingSoonTitle: "Coming soon", comingSoonText: "Our full list of services will be published here soon.",
      viewAll: "View all services",
    },
    about: {
      title: "About EliteTheBarber",
      text: "EliteTheBarber is a barbershop located at Vlampijpstraat 75g in Utrecht. We stand for craftsmanship, quality and a pleasant experience on every visit.",
    },
    reviews: {
      title: "What customers say", subtitle: "Genuine reviews from our customers via Google.",
      basedOn: "based on 37 Google reviews", source: "Source: Google Reviews",
    },
    hours: {
      title: "Opening Hours", closed: "Closed",
      days: { 0: "Monday", 1: "Tuesday", 2: "Wednesday", 3: "Thursday", 4: "Friday", 5: "Saturday", 6: "Sunday" },
    },
    location: {
      title: "Location", directions: "Get directions", viewOnMaps: "View on Google Maps",
    },
    contact: {
      title: "Contact", subtitle: "Get in touch or book an appointment directly.",
      phone: "Phone", email: "Email", address: "Address", hoursTitle: "Opening hours", bookCta: "Book an appointment now",
      form: {
        title: "Send us a message", subtitle: "Fill in the form and we'll get back to you as soon as possible.",
        name: "Name", email: "Email address", phone: "Phone number (optional)", message: "Message",
        namePlaceholder: "Your name", emailPlaceholder: "name@example.com", phonePlaceholder: "06 12345678",
        messagePlaceholder: "How can we help you?",
        submit: "Send message", sending: "Sending...",
        successTitle: "Message sent!", successMessage: "Thank you for your message. We'll get back to you as soon as possible.",
        errorMessage: "Something went wrong while sending. Please try again later or call us directly.",
      },
    },
    footer: {
      tagline: "Premium barbershop in Utrecht.", quickLinks: "Quick links", legal: "Legal",
      rights: "All rights reserved.",
      privacy: "Privacy Policy", cookies: "Cookie Policy", terms: "Terms & Conditions",
      admin: "Admin", manageAppointment: "Cancel appointment",
    },
    cookieBanner: {
      text: "This website only uses necessary and functional cookies to work properly (such as your language preference and login session). No tracking or marketing cookies are used.",
      accept: "Got it", moreInfo: "More info",
    },
    booking: {
      title: "Book your appointment",
      steps: { service: "Service", date: "Date", time: "Time", info: "Details", confirm: "Confirm" },
      selectService: "Choose a service", selectDate: "Choose a date", selectTime: "Choose a time",
      noServices: "There are currently no services available. Please contact us by phone.",
      noSlots: "No available times on this day. Please choose another date.",
      loadingSlots: "Loading available times...",
      form: {
        name: "Full name", email: "Email address", phone: "Phone number", notes: "Notes (optional)",
        namePlaceholder: "Your name", emailPlaceholder: "name@example.com", phonePlaceholder: "06 12345678",
        notesPlaceholder: "Any wishes or remarks",
      },
      consent: {
        text: "I agree to the", terms: "terms & conditions", and: "and have read the",
        privacy: "privacy policy", required: "You must agree to confirm your appointment.",
      },
      summary: {
        title: "Review your appointment", service: "Service", date: "Date", time: "Time", price: "Price",
        duration: "Duration", customer: "Name", email: "Email", phone: "Phone",
      },
      confirmButton: "Confirm appointment", confirming: "Confirming...",
      success: {
        title: "Appointment confirmed!", message: "Your appointment has been successfully scheduled. See you soon at EliteTheBarber!",
        reference: "Appointment number", backHome: "Back to home", newBooking: "Make a new booking",
        keepNumber: "Keep this number safe, you'll need it to cancel your appointment.",
        manageLink: "Cancel appointment?",
        spamTip: "Didn't receive a confirmation email after a few minutes? Check your spam/junk folder and mark it as \"not spam\" — future emails from us will then land in your inbox.",
      },
      errors: {
        slotTaken: "This time slot is no longer available. Please choose another time.",
        invalidData: "Please check the details you entered.", serverError: "Something went wrong. Please try again later.",
        noAvailability: "No availability found.", serviceUnavailable: "This service is not available.",
        generic: "An error occurred.",
      },
      changeSelection: "Change selection",
    },
    cancelPage: {
      title: "Cancel appointment", confirmText: "Are you sure you want to cancel this appointment? This cannot be undone.",
      confirmButton: "Yes, cancel my appointment", cancelledTitle: "Appointment cancelled",
      cancelledMessage: "Your appointment has been successfully cancelled. We hope to see you again soon!",
      invalidLink: "This link is invalid or has expired.", manageLink: "Prefer to reschedule instead?",
      policyNote: "You can cancel or reschedule free of charge up to 12 hours before your appointment. If you cancel within 12 hours, or in case of a no-show, 50% of the rate will be charged.",
    },
    reschedulePage: {
      title: "Reschedule appointment", currentAppointment: "Current appointment", newTime: "New date and time",
      confirmButton: "Confirm change", confirming: "Confirming...", successTitle: "Appointment rescheduled!",
      successMessage: "Your appointment has been successfully moved.", cancelLink: "Prefer to cancel instead?",
      policyNote: "You can reschedule free of charge up to 12 hours before your appointment. If you reschedule within 12 hours, or in case of a no-show, 50% of the rate will be charged.",
    },
    manageAppointmentPage: {
      title: "Cancel appointment", subtitle: "Enter your appointment number and email address to find your appointment.",
      appointmentNumber: "Appointment number", appointmentNumberPlaceholder: "E.g. 00003",
      email: "Email address", emailPlaceholder: "The email address you booked with",
      searchButton: "Find appointment", searching: "Searching...",
      notFound: "We couldn't find an appointment with these details. Check your appointment number and email address.",
      foundTitle: "Appointment found", alreadyCancelled: "This appointment has already been cancelled.",
      confirmText: "Are you sure you want to cancel this appointment?",
      cancelButton: "Cancel appointment", back: "Back", cancelling: "Cancelling...",
      cancelledTitle: "Appointment cancelled", cancelledMessage: "Your appointment has been successfully cancelled. We hope to see you again soon!",
      newSearch: "Find another appointment",
    },
    legal: {
      privacyTitle: "Privacy Policy", cookiesTitle: "Cookie Policy", termsTitle: "Terms & Conditions",
      lastUpdated: "Last updated",
    },
    admin: {
      login: {
        title: "Admin login", email: "Email address", password: "Password", submit: "Log in",
        invalidCredentials: "Invalid email or password", forgotPassword: "Forgot password?",
      },
      resetPassword: {
        title: "Set new password", newPassword: "New password", confirmPassword: "Confirm password",
        submit: "Set password", success: "Password successfully changed. You can now log in.",
        mismatch: "Passwords do not match", tooShort: "Password must be at least 8 characters",
        invalidToken: "This link is invalid or has expired. Please request a new one.", goToLogin: "Go to login",
        missingToken: "No reset token found in the link.",
      },
      nav: {
        dashboard: "Dashboard", calendar: "Calendar", bookings: "Bookings", availability: "Availability",
        services: "Services", photos: "Photos", messages: "Messages", reports: "Reports", settings: "Settings", logout: "Log out", backToSite: "Back to website",
      },
      dashboard: {
        title: "Dashboard", todayAppointments: "Appointments today", upcoming: "Next 7 days",
        totalBookings: "Total bookings", revenueMonth: "Revenue this month", quickActions: "Quick actions",
        newBooking: "Add new booking", viewCalendar: "View calendar", manageServices: "Manage services",
        noAppointmentsToday: "No appointments today.", upcomingAppointments: "Upcoming appointments",
        todayPanelTitle: "Today", noUpcoming: "No upcoming appointments.",
      },
      calendar: {
        title: "Calendar", day: "Day", week: "Week", month: "Month", today: "Today",
        noAppointments: "No appointments", prev: "Previous", next: "Next",
      },
      bookings: {
        title: "Bookings", all: "All", confirmed: "Confirmed", cancelled: "Cancelled",
        newBooking: "New booking", customer: "Customer", service: "Service", date: "Date", time: "Time",
        price: "Price", noBookings: "No bookings found.", cancelBooking: "Cancel",
        deleteBooking: "Delete", confirmCancel: "Are you sure you want to cancel this booking?",
        confirmDelete: "Are you sure you want to permanently delete this booking?",
        editBooking: "Edit booking", details: "Details", notes: "Notes", source: "Source",
        appointmentNumber: "Appointment number", searchPlaceholder: "Search by number, name, email, phone or date...",
        formDescription: "Fill in the appointment details and click save.",
      },
      availability: {
        title: "Availability", workingHours: "Working hours", breaks: "Breaks", blockedTimes: "Blocked times / Holidays",
        open: "Open", closed: "Closed", startTime: "Start time", endTime: "End time", addBreak: "Add break",
        addBlocked: "Add exception", fullDay: "Full day", reason: "Reason", startDate: "Start date", endDate: "End date",
        weekday: "Day", label: "Label", noBreaks: "No breaks configured.", noBlocked: "No exceptions configured.",
      },
      services: {
        title: "Services & Prices", addService: "Add service", editService: "Edit service",
        nameNl: "Name (NL)", nameEn: "Name (EN)", descriptionNl: "Description (NL)", descriptionEn: "Description (EN)",
        price: "Price (€)", duration: "Duration (min)", order: "Order", isActive: "Active", noServices: "No services added yet.",
        image: "Photo", uploadImage: "Upload photo",
      },
      photos: {
        title: "Manage photos", upload: "Upload photo", section: "Section", altTextNl: "Alt text (NL)",
        altTextEn: "Alt text (EN)", noPhotos: "No photos uploaded yet.", moveUp: "Move up", moveDown: "Move down",
        edit: "Edit", editPhoto: "Edit photo", replaceImage: "Replace image (optional)",
        save: "Save", saving: "Saving...", cancel: "Cancel", deleteConfirm: "Are you sure you want to delete this photo?",
        sections: { hero: "Hero", about: "About", services: "Services", gallery: "Gallery", contact: "Contact", carousel: "Carousel" },
      },
      messages: {
        title: "Contact messages", noMessages: "No messages received yet.", markRead: "Mark as read",
        deleteConfirm: "Delete message", deleteConfirmDescription: "Are you sure you want to permanently delete this message? This cannot be undone.",
        unread: "Unread", name: "Name", email: "Email", phone: "Phone", message: "Message", date: "Date",
      },
      reports: {
        title: "Reports", totalAppointments: "Appointments", totalRevenue: "Revenue", averagePrice: "Avg. price per appointment",
        cancelledCount: "Cancelled", byService: "Breakdown per service", chartTitle: "Revenue per day", chartTitleYear: "Revenue per month",
        noData: "No appointments in this period.", service: "Service", count: "Count", revenue: "Revenue",
        prevMonth: "Previous month", nextMonth: "Next month", prevYear: "Previous year", nextYear: "Next year",
        monthView: "Month", yearView: "Year",
      },
      settings: {
        title: "Settings", businessInfo: "Business information", legalInfo: "Legal information",
        businessName: "Business name", legalName: "Legal business name", kvkNumber: "KvK number",
        phone: "Phone", email: "Email address", privacyEmail: "Privacy email address", address: "Address",
        postalCode: "Postal code", city: "City", country: "Country", mapsUrl: "Google Maps embed URL",
        reviewScore: "Review score", reviewCount: "Number of reviews", retention: "Data retention period (months)",
      },
    },
  },
};
